module.exports = "p {\n  margin-top: 30vh;\n  line-height: 100px;\n  text-align: center;\n  color: #4285f4;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/no-access/no-access.component.css
// module id = ./src/app/components/no-access/no-access.component.css
// module chunks = main